module.exports = __webpack_public_path__ + "static/media/logo_simple.0a46c89f.png";